import { render } from "./multi-bet-area.vue?vue&type=template&id=d1e30152&scoped=true&ts=true"
import script from "./multi-bet-area.vue?vue&type=script&lang=ts"
export * from "./multi-bet-area.vue?vue&type=script&lang=ts"

import "./multi-bet-area.vue?vue&type=style&index=0&id=d1e30152&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1e30152"]])

export default __exports__